import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAddPlayer = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
        <path
            fill="#000"
            d="M14.963 12.75a5.256 5.256 0 0 1 5.25 5.25v.75h-1.5V18c0-2.07-1.68-3.75-3.75-3.75h-3c-2.07 0-3.75 1.68-3.75 3.75v.75h-1.5V18a5.256 5.256 0 0 1 5.25-5.25zm-1.5-8.25c2.07 0 3.75 1.68 3.75 3.75S15.532 12 13.462 12s-3.75-1.68-3.75-3.75 1.68-3.75 3.75-3.75m0 1.5a2.257 2.257 0 0 0-2.25 2.25 2.257 2.257 0 0 0 2.25 2.25 2.257 2.257 0 0 0 2.25-2.25A2.257 2.257 0 0 0 13.463 6M4.995 9.6h2.423v1.08H4.995v2.445h-1.08V10.68H1.5V9.6h2.415V7.125h1.08z"
        />
    </svg>
);
export default SvgAddPlayer;
